/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_FormatsInputs */

const cs_blog_website_formats = /** @type {(inputs: Blog_Website_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web dostane HTML nebo Markdown včetně úvodního a vložených obrázků (jako URL připravené k zobrazení).`)
};

const en_blog_website_formats = /** @type {(inputs: Blog_Website_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sites receive HTML or Markdown plus cover and inline images (as ready-to-use image URLs).`)
};

/**
* | output |
* | --- |
* | "Sites receive HTML or Markdown plus cover and inline images (as ready-to-use image URLs)." |
*
* @param {Blog_Website_FormatsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_formats = /** @type {((inputs?: Blog_Website_FormatsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_FormatsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_formats(inputs)
	return cs_blog_website_formats(inputs)
});